import React from 'react'

function Footer() {
    return (
        <footer className="footer">
        Coinvest Limited is an authorised Financial Services and registered Credit Provider (FSP5865, NCRCP6). Reg. No.: 2021/026515/08
        </footer>
    )
}

export default Footer
